import React from "react";
import { Modal, Input } from "antd";
import { isPending } from "@reduxjs/toolkit";

const ReviewPDFModals = ({
  isAddSubmittalModalOpen,
  setIsAddSubmittalModalOpen,
  newSubmittalName,
  setNewSubmittalName,
  subdivisionForNewSubmittal,
  setSubdivisionForNewSubmittal,
  isAddSubdivisionModalOpen,
  setIsAddSubdivisionModalOpen,
  newSubdivisionName,
  setNewSubdivisionName,
  pendingDeleteSubdivision,
  setPendingDeleteSubdivision,
  selectedDivision,
  setTableState,
  setActiveSubdivisionKeys,
  onSubmittalsChanged,
}) => {
  const handleAddSubmittal = () => {
    if (
      !newSubmittalName.trim() ||
      !subdivisionForNewSubmittal ||
      !selectedDivision
    )
      return;

    setTableState((prev) => {
      const newState = { ...prev };
      // Ensure immutability for the division and subdivision array
      const divisionData = { ...newState[selectedDivision] };
      const list = [...(divisionData[subdivisionForNewSubmittal] || [])];

      list.push({
        specTitle: newSubmittalName.trim(),
        specNumber: "",
        specRevision: "",
        specType: "",
        isPending: false,
        // Using Date.now() or crypto.randomUUID() is better than Math.random() for dndId
        dndId: crypto.randomUUID(),
      });

      divisionData[subdivisionForNewSubmittal] = list;
      newState[selectedDivision] = divisionData;
      // Save latest state atomically
      onSubmittalsChanged?.(newState);
      return newState;
    });

    // Reset and close
    setNewSubmittalName("");
    setSubdivisionForNewSubmittal(null);
    setIsAddSubmittalModalOpen(false);
  };

  const handleCancelSubmittal = () => {
    setNewSubmittalName("");
    setSubdivisionForNewSubmittal(null);
    setIsAddSubmittalModalOpen(false);
  };

  const handleDeleteSubdivision = () => {
    setTableState((prev) => {
      const newState = { ...prev };
      const divData = { ...newState[selectedDivision] };

      // Use destructuring assignment for clearer immutable deletion
      const { [pendingDeleteSubdivision]: _, ...restDivData } = divData;
      newState[selectedDivision] = restDivData;
      // Save latest state atomically
      onSubmittalsChanged?.(newState);
      return newState;
    });

    setActiveSubdivisionKeys((prev) =>
      prev.filter((k) => k !== pendingDeleteSubdivision),
    );
    setPendingDeleteSubdivision(null);
  };

  const handleAddSubdivision = () => {
    if (!newSubdivisionName.trim() || !selectedDivision) return;

    setTableState((prev) => {
      const newState = { ...prev };
      const div = selectedDivision;

      // Ensure immutability and place new subdivision at the top
      const existingDivData = newState[div] || {};
      newState[div] = {
        [newSubdivisionName.trim()]: [],
        ...existingDivData,
      };
      // Save latest state atomically
      onSubmittalsChanged?.(newState);
      return newState;
    });

    // Add new subdivision to the active keys list to open it
    setActiveSubdivisionKeys((prev) => [...prev, newSubdivisionName.trim()]);

    setNewSubdivisionName("");
    setIsAddSubdivisionModalOpen(false);
  };

  const handleCancelAddSubdivision = () => {
    setNewSubdivisionName("");
    setIsAddSubdivisionModalOpen(false);
  };

  return (
    <>
      {/* Add Submittal Modal */}
      <Modal
        title="Add Submittal"
        open={isAddSubmittalModalOpen}
        centered
        width={"400px"}
        onOk={handleAddSubmittal}
        onCancel={handleCancelSubmittal}
      >
        <Input
          placeholder="Submittal name"
          value={newSubmittalName}
          onChange={(e) => setNewSubmittalName(e.target.value)}
        />
      </Modal>

      {/* Delete Subdivision Modal */}
      <Modal
        title="Delete Subdivision"
        open={!!pendingDeleteSubdivision}
        centered
        width={"400px"}
        onOk={handleDeleteSubdivision}
        okText="Delete"
        okButtonProps={{ danger: true, type: "default" }}
        onCancel={() => setPendingDeleteSubdivision(null)}
      >
        <p>
          Are you sure you want to delete the subdivision
          <span className="font-weight-bold">
            {" "}
            "{pendingDeleteSubdivision}"
          </span>
          ?
        </p>
      </Modal>

      {/* Add Subdivision Modal */}
      <Modal
        title="Add Subdivision"
        open={isAddSubdivisionModalOpen}
        centered
        width={"400px"}
        onOk={handleAddSubdivision}
        onCancel={handleCancelAddSubdivision}
      >
        <Input
          placeholder="Subdivision name"
          value={newSubdivisionName}
          onChange={(e) => setNewSubdivisionName(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default ReviewPDFModals;
